import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DislikeTwoToneSvg from "@ant-design/icons-svg/es/asn/DislikeTwoTone";
import AntdIcon from "../components/AntdIcon";
var DislikeTwoTone = function DislikeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DislikeTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DislikeTwoTone.displayName = 'DislikeTwoTone';
}
export default /*#__PURE__*/React.forwardRef(DislikeTwoTone);